{
  "slug": "mensa-iq-requirements",
  "title": "شروح متطلبات معدل الذكاء",
  "description": "تعلم كيف يستخدم مؤهل Mensa أعلى 2٪، لماذا تختلف الأرقام المؤهلة باختلاف الاختبار، ولماذا لا تكون الدرجات على الإنترنت دليل قبول.",
  "summary": "ويصف Mensa الأهلية بأرقام مئوية: يجب أن تكون النتيجة المؤهلة في حدود أو أعلى من. 98معدل الذكاء المقابل يختلف بحسب المقياس.",
  "category": "المقارنات",
  "sections": [
    {
      "heading": "الشرط هو نسبة مئوية، وليس رقما عالميا واحدا",
      "paragraphs": [
        "وتذكر منظمة مينسا الدولية أن العضوية مفتوحة للأشخاص الذين يحصلون على درجات في حدود أعلى 2 في المائة من السكان عموما في اختبار ذكاء معتمد تم إدارته والإشراف عليه بشكل سليم.",
        "الـ 98وغالبا ما يكون المئين الثامن قريبا من 100 في المائة. 130 على مدى100, SD- )الجزء اﻷول(15 ويستخدم الاختباران المذكوران أعلاه مقياساً واحداً، ولكن الاختبارات الأخرى تستخدم انحرافات معيارية وأنواع درجات وعتبات مختلفة."
      ]
    },
    {
      "heading": "طرق توفير نتيجة مؤهلة",
      "paragraphs": [
        "وتبعاً لمنظمة Mensa الوطنية، قد يخضع المرشح لاختبار قبول أو يقدم أدلة من تقييم آخر معتمد.وتختلف الإجراءات، والقيود على السن، والصكوك المقبولة، والوثائق من بلد إلى آخر.",
        "1- الاحتفاظ بتقرير الدرجات المهنية الأصلي، والاتصال بمكتب Mensa ذي الصلة قبل ترتيب إجراء اختبار خارجي إذا كان الغرض هو التأهيل."
      ]
    },
    {
      "heading": "ماذا يمكن أن تفعل الممارسة والاختبارات على الإنترنت",
      "paragraphs": [
        "إن أسئلة الممارسة من الممكن أن تساعد المرء في فهم الأشكال والتوقيت. وهي لا تثبت الأهلية، وقد يحسن التعرض المتكرر الإلمام بدلاً من قياس التغير المستقر في القدرة العامة.",
        "تذكر منظمة Mensa الدولية أنه لا يمكن استخدام الاختبارات على الإنترنت للقبول، وأن النتائج التي يتم الحصول عليها على الإنترنت تعتبر تعليمية أو إرشادية ما لم تذكر المنظمة المتلقية صراحة خلاف ذلك."
      ]
    }
  ],
  "faqs": [
    {
      "question": "ما هو معدل الذكاء الذي تحتاجه للالتحاق بـ (مينسا)؟",
      "answer": "تستند الأهلية إلى معدلات الدخل السنوية. 98100 في المائة في اختبار معتمد تحت الإشراف. ويختلف العدد المعادل حسب مقياس الاختبار."
    },
    {
      "question": "هل يمكنني الانضمام إلى \"مينسا\" بنتيجة اختبار الذكاء على الإنترنت؟",
      "answer": "وتذكر منظمة مينسا الدولية أنه لا يمكن استخدام الاختبارات الإلكترونية للقبول."
    }
  ],
  "related": ["iq-test-vs-mensa-test", "what-is-considered-a-high-iq", "iq-percentiles"],
  "sources": [
    {
      "label": "Mensa International - اختبار معدل الذكاء",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
